<template>
  <div
    class="h-fit rounded-lg bg-white px-3 py-4 drop-shadow-lg w-[250px] md:w-[300px] md:p-4"
  >
    <p class="pig !font-bold mb-3">
      {{ $t('checkout.input.cvvCheck.tooltipTitle') }}
    </p>

    <p class="beaver">
      {{ $t('checkout.input.cvvCheck.tooltipDescription') }}
    </p>
  </div>
</template>
